module.exports = {"apiKeyValidationRegex":"^[a-zA-Z0-9-]*$","cookiePart":"r3ddr0v3r","customerNotFoundTimeRangeMinutes":30,"logLevel":"error","roverBaseUrl":"https://roverdev01.samsclub.com"}


//////////////////
// WEBPACK FOOTER
// ./src/config/default.json
// module id = 526
// module chunks = 5